<template>
  <v-alert v-if="error.messages" border="left" type="error" elevation="2">
    <v-list dense class="pa-0">
      <v-list-item
        v-for="(errorMessage, index) in error.messages"
        :key="index"
        class="pa-0"
      >
        <v-list-item-content>
          <v-list-item-title>
            {{ errorMessage }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-alert>
</template>

<script>
export default {
  name: "BaseAlert",
  props: ["error"],
};
</script>
